export default "<!-- angly Menu -->\n<div angly-menu></div>\n"